import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import CheckoutController from './controllers/checkout-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import CustomSelect from './controllers/custom-select-controller';
import ExpandableController from './controllers/expandable-controller';
import LeafletController from './controllers/leaflet-controller';
import MiniCartController from './controllers/mini-cart-controller';
import MobileController from './controllers/mobile-controller';
import ModalController from './controllers/modal-controller';
import ProductFilterController from './controllers/product-filter-controller';
import QuantityController from './controllers/quantity-controller';
import SectorsController from './controllers/sectors-controller';
import SplideController from './controllers/splide-controller';
import { throttle } from './utils';

__webpack_public_path__ = document.querySelector('meta[name="theme-url"]').getAttribute('content');

const Stimulus = Application.start();

Stimulus.register('axios-form', AxiosFormController);
Stimulus.register('custom-select', CustomSelect);
Stimulus.register('cookie-bar', CookieBarController);
Stimulus.register('sectors', SectorsController);
Stimulus.register('splide', SplideController);
Stimulus.register('modal', ModalController);
Stimulus.register('expandable', ExpandableController);
Stimulus.register('leaflet', LeafletController);
Stimulus.register('quantity', QuantityController);
Stimulus.register('product-filter', ProductFilterController);
Stimulus.register('mini-cart', MiniCartController);
Stimulus.register('checkout', CheckoutController);
Stimulus.register('mobile', MobileController);

const el = document.getElementById('the-header');

if (el) {
  let isSticky = false;

  function updateSticky() {
    if (document.documentElement.scrollTop === 0) {
      if (isSticky) {
        el.classList.remove('pinned');
        isSticky = false;
      }

      return;
    }

    if (!isSticky) {
      el.classList.add('pinned');
      isSticky = true;
    }
  }

  window.addEventListener('scroll', throttle(() => {
    updateSticky();
  }, 50, {
    trailing: true,
  }));

  updateSticky();
}

(function ($) {
  let $billingPostcode = $('#billing_postcode');
  let billingPostcodeValue = '';
  let $shippingPostcode = $('#shipping_postcode');
  let shippingPostcodeValue = '';
  let $billingState = $('#billing_state');
  let billingStateValue = '';
  let $shippingState = $('#shipping_state');
  let shippingStateValue = '';

  // Apply UIBlock to separated checkout elements from defaults
  $(document.body).on('update_checkout', () => {
    // prevent autofill double trigger
    billingPostcodeValue = $billingPostcode.val();
    shippingPostcodeValue = $shippingPostcode.val();

    $('.update-checkout-block').block({
      message: null,
      overlayCSS: {
        background: '#ffffff',
        opacity: 0.6,
      },
    });
  });

  $billingPostcode
    .on('focus', () => {
      billingPostcodeValue = $billingPostcode.val();
    })
    .on('blur', () => {
      if (billingPostcodeValue !== $billingPostcode.val()) {
        $('form.woocommerce-checkout').trigger('update');
      }
    });

  $shippingPostcode
    .on('focus', () => {
      shippingPostcodeValue = $shippingPostcode.val();
    })
    .on('blur', () => {
      if (shippingPostcodeValue !== $shippingPostcode.val()) {
        $('form.woocommerce-checkout').trigger('update');
      }
    });

  $billingState
    .on('focus', () => {
      billingStateValue = $billingState.val();
    })
    .on('blur', () => {
      if (billingStateValue !== $billingState.val()) {
        $('form.woocommerce-checkout').trigger('update');
      }
    });

  $shippingState
    .on('focus', () => {
      shippingStateValue = $shippingState.val();
    })
    .on('blur', () => {
      if (shippingStateValue !== $shippingState.val()) {
        $('form.woocommerce-checkout').trigger('update');
      }
    });

  if ($('.single-product #frakciju-dydziai-nominalus-dydis').length) {
    const data = $('.variations_form.cart').data('product_variations');
    const defaultText = $('.shipping-interval__text').html();
    $('#frakciju-dydziai-nominalus-dydis').change(() => {
      const index = parseInt($('option:selected',this).index()) - 1;

      if (index >= 0 && data[index].attributes.attribute_pa_pristatymas) {
        let shippingOption = $(`#pa_pristatymas option[value="${data[index].attributes.attribute_pa_pristatymas}"]`);
        let shippingInterval = shippingOption.text();
        $('.shipping-interval').css('display', 'inline-flex');
        $('.shipping-interval__text--days').text(shippingInterval);
        $('#pa_pristatymas').val(data[index].attributes.attribute_pa_pristatymas).trigger('change');
      } else if (index >= 0) {
        $('.shipping-interval').css('display', 'inline-flex');
        $('.shipping-interval__text').html(defaultText);
      } else {
        $('.shipping-interval').css('display', 'none');
      }
    });
  }
})(jQuery);
